import React from 'react';
import './projects-header.css'

export default function ProjectsHeader() {

    return (
        <div className="projects-header">
            <h1>My Projects</h1>
            <p>
                Here are some of the projects I have worked on.
            </p>
        </div>
    )
}